<div class='container-result-exams'>
    <app-exams *ngIf='!error && patientId' [isPageResultExams]='true' [patientId]='patientId' (emmitEventError)='eventError($event)'></app-exams>
    <section *ngIf='error' class='wrapper-error'>
        <div class='content'>
            <h2>Sessão inválida!</h2>
            <p>Por favor, tente novamente</p>
        </div>
    </section>
</div>
